import { render, staticRenderFns } from "./add-retrieval.vue?vue&type=template&id=b767765a&scoped=true"
import script from "./add-retrieval.vue?vue&type=script&lang=js"
export * from "./add-retrieval.vue?vue&type=script&lang=js"
import style0 from "./add-retrieval.vue?vue&type=style&index=0&id=b767765a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b767765a",
  null
  
)

export default component.exports